function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _templateObject, _templateObject2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

function getMousePosition(event) {
  var rect = event.target.getBoundingClientRect();
  var x = event.clientX - rect.left; //x position within the element.

  var y = event.clientY - rect.top; //y position within the element.

  return {
    x: x,
    y: y
  };
}

var rippleAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(50);\n  }\n"])));
var RippleSpan = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute !important;\n  width: 30px;\n  height: 30px;\n  margin-left: -15px;\n  margin-top: -15px;\n  border-radius: 50%;\n  opacity: 0.2;\n  transform: scale(50);\n  pointer-events: none;\n  animation: ", " ", " ease;\n  left: ", ";\n  top: ", ";\n  background-color: currentColor;\n"])), rippleAnimation, function (props) {
  return props.animationDuration;
}, function (props) {
  return props.left;
}, function (props) {
  return props.top;
});

var Ripple = /*#__PURE__*/function (_React$Component) {
  _inherits(Ripple, _React$Component);

  var _super = _createSuper(Ripple);

  function Ripple() {
    var _this;

    _classCallCheck(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      ripple: null
    });

    _defineProperty(_assertThisInitialized(_this), "isRippleMounted", false);

    _defineProperty(_assertThisInitialized(_this), "removeRipple", function (id) {
      var ripple = _this.state.ripple;

      if (!_this.isRippleMounted || !ripple) {
        return;
      }

      if (ripple.id === id) {
        var now = Date.now();

        if (now - ripple.id < 200) {
          /**
           * If the remove is triggered within 200ms, provide
           * at least 300ms more for the animation to complete
           */
          setTimeout(function () {
            _this.setState({
              ripple: null
            });
          }, 300);
        } else {
          _this.setState({
            ripple: null
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showRipple", function (event) {
      var _getMousePosition = getMousePosition(event),
          x = _getMousePosition.x,
          y = _getMousePosition.y;

      var id = Date.now();

      _this.animateRipple(id, x, y);
    });

    _defineProperty(_assertThisInitialized(_this), "createRippleDeactivateCallback", function (id) {
      var endRipple = function endRipple() {
        document.removeEventListener('mouseup', endRipple);

        _this.removeRipple(id);
      };

      return endRipple;
    });

    _defineProperty(_assertThisInitialized(_this), "addRippleDeactivateEventListener", function (id) {
      var endRipple = _this.createRippleDeactivateCallback(id);

      document.addEventListener('mouseup', endRipple);
      return endRipple;
    });

    _defineProperty(_assertThisInitialized(_this), "animateRipple", function (id, x, y) {
      var endRipple = _this.addRippleDeactivateEventListener(id);

      _this.setState({
        ripple: {
          id: id,
          left: "".concat(x, "px"),
          top: "".concat(y, "px"),
          endRipple: endRipple
        }
      });
    });

    return _this;
  }

  _createClass(Ripple, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof this.props.children !== 'function') {
        throw new Error('Ripple takes a function as children.');
      }

      this.isRippleMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isRippleMounted = false;

      if (this.state.ripple && this.state.ripple.endRipple) {
        this.state.ripple.endRipple();
      }
    }
  }, {
    key: "renderRipple",
    value: function renderRipple() {
      var ripple = this.state.ripple;

      if (!ripple) {
        return null;
      }

      var id = ripple.id,
          left = ripple.left,
          top = ripple.top;
      return /*#__PURE__*/React.createElement("span", {
        key: id
      }, /*#__PURE__*/React.createElement(RippleSpan, {
        animationDuration: "2s",
        left: left,
        top: top
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var ripple = this.renderRipple();
      var showRipple = this.showRipple;
      return this.props.children({
        ripple: ripple,
        showRipple: showRipple
      });
    }
  }]);

  return Ripple;
}(React.Component);

Ripple.displayName = 'Ripple';
export { Ripple };
export default Ripple;